import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Typography, Button } from '@mui/material';
import { AnimatedOnScroll } from 'react-animated-css-onscroll';
import ReactMarkdown from 'react-markdown';
import { Link } from '@material-ui/core';

// Styles
const useStyles = makeStyles((theme) => ({
  image: {
    position: 'relative',
    paddingTop: 80,
    height: 350,
    width: 500,
    zIndex: 101,
    marginLeft: 20,
    marginBottom: theme.spacing(30),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(4),
      width: 200,
      margin: '0 auto',
    },
  },
  button: {
    marginTop: 20,
    marginRight: 10,
    fontWeight: 600,
    width: 128,
    height: 48,
  },
  subHeader: {
    color: theme.palette.interactive.main,
    textTransform: 'uppercase',
    textAlign: 'left',
    fontSize: '30px',
  },
  smallSubHeader: {
    marginTop: 30,
    textAlign: 'left',
    fontSize: 18,
  },
  header: {
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    textAlign: 'left',
  },
  backgroundBox: {
    position: 'absolute',
    zIndex: 1,
    backgroundColor: theme.palette.alternative.main,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  bottomSubTitle: {
    textAlign: 'center',
    fontStyle: 'italic',
    [theme.breakpoints.down('md')]: {
      alignItems: 'flex-start',
    },
  },
  bodyText: {
    fontSize: '1rem',
    lineHeight: 1.7,
  },
}));

const Career = (props) => {
  const classes = useStyles();
  const { data } = props;

  return (
    <Grid container alignItems="flex-start" spacing={4}>
      <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
        <Box position="relative" zIndex="100">
          <AnimatedOnScroll animationIn="fadeIn" animationInDuration={1000}>
            <Typography variant="h5" className={classes.subHeader}>{data.careerOpportunitiesTitle1}</Typography>
            <Typography variant="h3" className={classes.header}>{data.careerOpportunitiesSubTitle1}</Typography>
            <ReactMarkdown variant="h6" className={classes.bodyText}>{data.careerRichField}</ReactMarkdown>
            <Typography variant="h6" className={classes.smallSubHeader}>Vacant positions:</Typography>
            <Button
              href="https://jobbiwideroe.no/karriere-i-wideroe/bakkepersonell/"
              variant="contained"
              className={classes.button}
              size="large"
              color="primary"
            >
              JOBBIWIDERØE
            </Button>
          </AnimatedOnScroll>
        </Box>
        <AnimatedOnScroll animationIn="fadeIn" animationInDuration={1000}>
          <Box pt={10}>
            <Grid container spacing={1} alignItems="center">
              <Grid item>
                <Typography variant="body1" className={classes.bodyText}>For more career inspiration visit: </Typography>
              </Grid>
              <Grid item>
                <Link href="https://jobbiwideroe.no/" target="_blank">
                  <img src="/static/images/WideroeIcon.svg" width={100} height={50} alt="WGH logo" />
                </Link>
              </Grid>
            </Grid>
          </Box>
        </AnimatedOnScroll>
      </Grid>
      <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
        <Box position="relative">
          <AnimatedOnScroll className={classes.image} animationIn="fadeIn" animationInDuration={1000}>
            <Box className={classes.image}>
              <Typography variant="h4" className={classes.bottomSubTitle}>{data.careerOpportunitiesSubTitle2}</Typography>
            </Box>
          </AnimatedOnScroll>
          <AnimatedOnScroll animationIn="fadeIn" animationInDuration={500} screenOffset={-350}>
            <Box
              className={classes.backgroundBox}
              top={100}
              left={-200}
              width={550}
              height={380}
            />
          </AnimatedOnScroll>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Career;
